export default {"src":"/_next/static/image/public/images/ic_lab_records_inprogress.963c73b294475f96bfd9f9f69b39beb2.svg","height":168,"width":153};